"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.models = exports.providers = void 0;

var _SchemaProvider = require("./SchemaProvider");

var _schema = require("./models/schema");

var providers = {
  SchemaProvider: _SchemaProvider.SchemaProvider
};
exports.providers = providers;
var models = {
  schemaModel: _schema.schemaModel
};
exports.models = models;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/reflection/index.js
// module id = 76
// module chunks = 0